<template>
  <div :class="[$style.distributor, !locationIsUsOrCan && $style.hideState]">
    <div :class="$style.logoWrapper">
      <BasePicture
        v-if="
          computedShowLogo && computedGroup?.fields?.logo?.fields?.file?.url
        "
        :img-class="$style.logo"
        :src="`${computedGroup?.fields?.logo?.fields?.file?.url}?w=240&fit=thumb&fm=webp`"
        alt=""
      />
    </div>
    <NuxtLinkLocale
      v-if="computedWebsiteUrl"
      :to="computedWebsiteUrl"
      target="_blank"
      >{{ data?.fields?.companyName }}</NuxtLinkLocale
    >
    <div v-else>{{ data?.fields?.companyName }}</div>
    <div>{{ computedPhone }}</div>
    <div>{{ data?.fields?.city }}</div>
    <div v-if="locationIsUsOrCan">{{ data?.fields?.state?.fields?.label }}</div>
    <div>{{ data?.fields?.country?.fields?.label }}</div>
  </div>
</template>

<script setup lang="ts">
import type {
  TypeDistributorGroupWithoutUnresolvableLinksResponse,
  TypeDistributorWithoutUnresolvableLinksResponse,
} from '~/types/contentful'

interface IDistributorWithConglomerate extends TypeDistributorWithoutUnresolvableLinksResponse {
  conglomerate: TypeDistributorGroupWithoutUnresolvableLinksResponse
}

const props = defineProps<{
  data: IDistributorWithConglomerate
  locationFilter: string
  locationIsUsOrCan: boolean
  groups: TypeDistributorGroupWithoutUnresolvableLinksResponse[]
  sortedEntries: IDistributorWithConglomerate[]
  sort: string
}>()

// Computed
const computedGroup = computed(() =>
  props?.groups?.find?.(
    (group) => group?.sys?.id === props?.data?.conglomerate?.sys?.id,
  ),
)

const computedShowLogo = computed(() => {
  const firstInGroup = props.sortedEntries?.find?.(
    (d) => d.conglomerate?.sys?.id === props.data?.conglomerate?.sys?.id,
  )
  return (
    firstInGroup?.sys?.id === props.data?.sys?.id ||
    props?.sort?.includes?.('region') ||
    props?.sort?.includes?.('country') ||
    props.locationFilter !== ''
  )
})

const computedWebsiteUrl = computed(
  () => props?.data?.fields?.website || computedGroup?.value?.fields?.website,
)
const computedPhone = computed(
  () =>
    props?.data?.fields?.phoneNumber ||
    computedGroup?.value?.fields?.phoneNumber,
)
</script>

<style lang="scss" module>
.distributor {
  align-items: center;
  display: grid;
  gap: 5px;
  grid-template-columns: 1fr;
  justify-content: center;
  padding: 15px 0;
  text-align: center;

  @include media('xl') {
    gap: 15px;
    grid-template-columns: 120px 1.25fr 1fr 1fr 1.1fr 1.2fr;
  }

  &.hideState {
    @include media('xl') {
      grid-template-columns: 120px 1fr 1fr 1fr 1fr;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--gray-3);
  }
}

.logo {
  max-width: 100%;
}
</style>
